export function scrollWindowToTopSmooth() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}
